import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("optics_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to subscribe page when the backend plan gate returns 402
let redirecting402 = false;
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 402 && !redirecting402 && window.location.pathname !== "/subscribe") {
      redirecting402 = true;
      window.location.assign("/subscribe");
    }
    return Promise.reject(error);
  }
);

export const nzd = (n) =>
  `$${Number(n || 0).toLocaleString("en-NZ", { maximumFractionDigits: 0 })}`;
export const num = (n, d = 0) =>
  Number(n || 0).toLocaleString("en-NZ", { maximumFractionDigits: d });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
